import React from "react";
import { motion } from "framer-motion";
import { cardVariants, cardVariantYs } from "../../utils/variable";
import togue from "../../assets/img/icone_toque_rouge.png";

export default function Titre({ children, soustitre, icon, color = null }) {
  return (
    <div className="text-center my-5">
      {/* <img
        loading="lazy"
        src={togue}
        alt=""
        className="text-center"
        width={50}
        height={50}
      /> */}

      <motion.h1
        initial="offscreen"
        whileInView="onscreen"
        variants={cardVariants}
        viewport={{ once: true, amount: 0.8 }}
        // si color true mettre text-white
        className={`custom-titre-h1 fw-bold ${color ? "text-white" : ""}`}
      >
        {children}
      </motion.h1>
{/* 
      <motion.p
        initial="offscreen"
        whileInView="onscreen"
        variants={cardVariants}
        viewport={{ once: true, amount: 0.8 }}
        className={`custom-sous-titre-h2 fw-bold ${color ? "text-white" : ""}`}
      >
        {soustitre}
      </motion.p> */}

      {/* <motion.div
        initial="offscreen"
        whileInView="onscreen"
        variants={cardVariantYs}
        viewport={{ once: true, amount: 0.8 }}
        className="custom-titre-icon"
      >
        <span
          style={{
            display: "inline-block",
            width: "20px",
            height: "20px",
            backgroundColor: "red",
            borderRadius: "50%",
            border: "4px solid white",
          }}
        ></span>
      </motion.div> */}
       
    </div>
  );
}
